module.exports = __webpack_public_path__ + "img/angle-top.cbf6bd18.svg";